import { Service } from '@angular/core';

@Service({ autoProvided: false })
export class StartschermV2FormatteerInternalService {
    formatteerKlantnummer(nummer: string): string {
        if (nummer && this.isKlantnummerGeldig(nummer)) {
            let result = this.onformatteerKlantnummer(nummer);

            //add leading zero if string length is smaller than 11
            if (result.length < 11) {
                result = '0'.repeat(11 - result.length) + result;
            }

            result = result.slice(0, 3) + '.' + result.slice(3, 6) + '.' + result.slice(6, 9) + '-' + result.slice(9, 11);

            return result;
        }

        return nummer;
    }

    onformatteerKlantnummer(nummer: string): string {
        if (nummer) {
            let result = nummer;

            //remove non-alphanumeric chars
            result = result.replace(/[^a-zA-Z0-9]*/gm, '');

            //trim leading zero if string length is larger than 11
            if (result.length > 11) {
                result = result.replace(/^0+/, '');
            }

            //add leading zero if string length is smaller than 11
            if (result.length < 11) {
                result = '0'.repeat(11 - result.length) + result;
            }

            return result;
        }

        return nummer;
    }

    isKlantnummerGeldig(nummer: string): boolean {
        if (nummer) {
            const ongeformatteerd = this.onformatteerKlantnummer(nummer);

            if (ongeformatteerd.length != 11) {
                return false;
            }

            if (ongeformatteerd.match(/[^0-9]/gm)) {
                return false;
            }

            const deel1 = parseInt(ongeformatteerd.slice(0, -2));
            let deel2 = parseInt(ongeformatteerd.slice(-2));

            if (deel2 == 0) {
                return false;
            }

            if (deel2 == 97) {
                deel2 = 0;
            }

            if (deel1 % 97 != deel2) {
                return false;
            }
        }

        return true;
    }
}
